// extracted by mini-css-extract-plugin
export var footer = "_op-5";
export var fulfillmentInput = "_op-0";
export var shipDateInput = "_op-1";
export var shipmentModal = "_op-2";
export var shipmentModalContent = "_op-3";
export var tableContainer = "_op-4";